// extracted by mini-css-extract-plugin
export default {"breakpointPostContentAreaMin":"746px","breakpointPostContentAreaSmall":"900px","container":"n2kP6","profile":"ofIGm","search":"phRpy","reply":"Gtvms"};